import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { FormControl, FormGroup } from '@angular/forms';
import { StaticMessage } from '@shared/enums';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
  ViewChild,
} from '@angular/core';
import { tap } from 'rxjs';

import { DateRangePickerComponent } from '../date-range-picker/date-range-picker.component';

@UntilDestroy()
@Component({
  selector: 'app-download-dpr-modal',
  templateUrl: './download-dpr-modal.component.html',
  styleUrls: ['./download-dpr-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadDprModalComponent implements OnInit {
  @ViewChild(DateRangePickerComponent) rangePicker: DateRangePickerComponent;

  downloadFormControl = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
    includeReports: new FormControl<boolean>(false),
    includeSignedReports: new FormControl<boolean>(false),
    includeAttachments: new FormControl<boolean>(false),
    includeAppendices: new FormControl<boolean>(false),
  });

  StaticMessage = StaticMessage;
  isDownloadButtonDisabled = true;

  constructor(
    private dialogRef: MatDialogRef<DownloadDprModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      startDate: Date;
      endDate: Date;
    }
  ) {}

  ngOnInit(): void {
    this.setupFormControl();

    this.downloadFormControl.valueChanges
      .pipe(
        untilDestroyed(this),
        tap((change) => {
          this.isDownloadButtonDisabled =
            !change.includeReports &&
            !change.includeSignedReports &&
            !change.includeAttachments &&
            !change.includeAppendices;
        })
      )
      .subscribe();
  }

  onDownload(): void {
    this.downloadFormControl.patchValue({
      ...this.downloadFormControl.value,
      startDate: this.rangePicker.startDate,
      endDate: this.rangePicker.endDate,
    });

    this.dialogRef.close(this.downloadFormControl.value);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  //#region Private methods

  private setupFormControl(): void {
    this.downloadFormControl.patchValue({
      startDate: this.data.startDate,
      endDate: this.data.endDate,
    });
  }

  //#endregion
}
